import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

interface ProtectedRouteProps {
    children: ReactNode;
}

/**
 * Wraps a route and ensures the user is authenticated.
 * If not authenticated, it redirects to the /login page.
 */
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    useMsalAuthentication(InteractionType.None);

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
